export const skipWeekend = (date: Date) => {
  const dateSkippingWeekend = new Date(date);
  const offsetToMonday = (dateSkippingWeekend.getDay() * -1 + 8) % 7;
  if (offsetToMonday > 0 && offsetToMonday <= 2) {
    dateSkippingWeekend.setDate(dateSkippingWeekend.getDate() + offsetToMonday);
  }
  return dateSkippingWeekend;
};
